import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

interface AbaCodeBrand {
    readonly AbaCode: unique symbol;
}

export const AbaCode = brand(
    NonEmptyString,
    (_n: string): _n is Branded<NonEmptyString, AbaCodeBrand> => true,
    'AbaCode'
);
export type AbaCode = TypeOf<typeof AbaCode>;
